<div class="modal-header">
    <h4 class="modal-title">{{surveyName}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
  <!-- Module Selection UI -->
  <div class="container text-center mt-4" *ngIf="beforeCardclick">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2 mb-3" *ngFor="let item of filteredModules">
        <img [src]="item.icon" width="100" height="100" (click)="navigateTo(item, item.label)" style="cursor: pointer;" class="hover-img">
      </div>
    </div>
  </div>

  <!-- Survey Card Selection -->
  <div class="row" *ngIf="!cardClick && !beforeCardclick">
    <div class="col-md-4 mb-3" *ngFor="let survey of surveyCards; let i = index">
      <div class="card text-white mb-3 card-hover-effect" [ngClass]="getCardColor(i)" (click)="onCardClick(survey)" style="cursor: pointer; border-radius: 10px;">
        <div class="card-body text-center" [ngClass]="{ 'bg-success': completedSurveys[survey] }">
          <i class="{{ getCardIcon(i) }} fa-2x mb-2"></i>
          <h5 class="card-title">{{ survey }}</h5>
        </div>
      </div>
    </div>
  </div>

  <!-- Questionnaire Tabs -->
  <div *ngIf="cardClick" class="mt-4">
   <ul class="nav nav-tabs mb-3">
  <li class="nav-item" *ngFor="let section of selectedSurvey?.sections; let i = index">
    <a class="nav-link" 
       [class.active]="i === activeTabIndex" 
       href="javascript:void(0)" 
       (click)="handleTabClick(i)">
      {{ getSectionLabel(section, i) }}
    </a>
  </li>
</ul>


    <!-- Section Questions -->
  <div *ngIf="selectedSurvey?.sections[activeTabIndex] as activeSection">
    <ng-container *ngIf="activeSection.sectionLang[0]?.langStr === 'Referral'">
  <div class="row">
    <div *ngFor="let sec of activeSection.previousSections" class="col-12 mb-2">
      <div class="section-card p-2 border rounded">
        <h5 class="mb-3">{{ sec.sectionName }}</h5>

        <!-- Loop through questions -->
       <div *ngFor="let q of sec.questions" class="d-flex align-items-center mb-2">
         <div *ngIf="q.gender === selectedGenderId || q.gender === 'All' || q.gender == null">
  <!-- Question -->
  <div class="font-weight-bold" style="color: rgba(0, 0, 0, 0.751);font-size: 14px; flex: 0 0 auto; min-width: 200px;">
    {{ getQuestionLabel(q) || q.placeHolder }} : &nbsp;&nbsp;
  </div>

  <!-- Answer -->
  <div class="flex-grow-1 ms-3" style="color: hwb(0 0% 100% / 0.658);font-size: 14px;">
    <!-- Radio Button -->
    <ng-container *ngIf="q.answerType?.name === 'Radio Button'">
      {{ selectedAnswers[q.id] ? 'Yes' : 'No' }}
    </ng-container>

    <!-- Checkbox -->
    <ng-container *ngIf="q.answerType?.name === 'Checkbox'">
      {{ selectedAnswers[q.id] ? 'true' : 'false' }}
    </ng-container>

    <!-- Date / Text -->
    <ng-container *ngIf="q.answerType?.name !== 'Radio Button' && q.answerType?.name !== 'Checkbox'">
      <span *ngIf="q.answerType?.name === 'Current Date' || q.answerType?.name === 'Calendar Date'">
        {{ selectedAnswers[q.id] | date:'dd-MM-yyyy' }}
      </span>
      <span *ngIf="q.answerType?.name !== 'Current Date' && q.answerType?.name !== 'Calendar Date'">
        {{ selectedAnswers[q.id] || '-' }}
      </span>
    </ng-container>
  </div>

  </div>
</div>


      </div>
    </div>
  </div>
<div class="row">
  <div class="col-xl-12">
    <h3 class="mb-3">Referral</h3>
  </div>
  <div class="col-xl-3">
    <div class="form-group">
      <label>Name of Referral Facility</label><br>
      <label class="ml-1 mr-1"><input type="radio" name="referralFacility" value="underTreatment">
        Under treatment</label>
      <label class="ml-1 mr-1"><input type="radio" class="ml-1 mr-1" name="referralFacility" value="yes">Yes</label>
      <label class="ml-1 mr-1"><input type="radio" class="ml-1 mr-1" name="referralFacility" value="no">No</label>
    </div>
  </div>
  <div class="col-xl-3">
    <div class="form-group">
      <label for="referTo" class="mr-2">Refer To</label>
      <select id="referTo" class="form-control form-control-sm" name="referTo">
        <option value="">Select</option>
        <option value="hospital">Hospital</option>
        <option value="clinic">Clinic</option>
        <option value="specialist">Specialist</option>
      </select>
    </div>
  </div>
  <div class="col-xl-3">
    <div class="form-group">
      <label for="remarks">Remarks</label>
      <input type="text" id="remarks" class="form-control form-control-sm" name="remarks" placeholder="Enter remarks">
    </div>
  </div>
</div>
</ng-container>

  <div class="row">
   <ng-container *ngIf="activeSection.sectionLang[0]?.langStr !== 'Referral'">
    <ng-container *ngFor="let question of activeSection.questions;let i = index;">
      <ng-container *ngIf="shouldDisplayQuestion(question)">

          <!-- Text Box -->
          <div *ngIf="question.answerType.name === 'Text Box' || question.answerType.name === 'text' " class="col-xl-6 col-lg-6 col-md-12 mb-4">
            <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
                {{ getQuestionNumber(i,question) }} {{ getQuestionLabel(question) }}
              <span *ngIf="question.mandatory" class="text-danger">*</span>
            </label>
          
            <input type="text" class="form-control form-control-sm" [(ngModel)]="selectedAnswers[question.id]"
              [name]="'q' + question.id" [readonly]="getQuestionLabel(question)?.toLowerCase().includes('bmi')"
              (change)="updateSurveyDetail(question, $event,i,activeSection, 'text'); clearError(question.id)" [required]="isMandatory(question)">
          
            <div class="text-danger mt-1" *ngIf="errors[question.id]">This field is required</div>
          
            <!-- ✅ BMI Result Text -->
            <div *ngIf="getQuestionLabel(question)?.toLowerCase().includes('bmi') && selectedAnswers[question.id]">
              <small class="mt-1 font-weight-bold d-block" [style.color]="bmiTxtClr(selectedAnswers[question.id], 'c')">
                {{ bmiTxtClr(selectedAnswers[question.id], 't') }}
              </small>
            </div>
          </div>


          <!-- Dropdown -->
          <div *ngIf="question.answerType.name === 'Dropdown'" class="col-xl-6 col-lg-6 col-md-12 mb-4">
            <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
                {{ getQuestionNumber(i,question) }} {{ getQuestionLabel(question) }}
              <span *ngIf="question.mandatory" class="text-danger">*</span>
            </label>
            <select class="form-control form-control-sm"
                    [(ngModel)]="selectedAnswers[question.id]"
                    [name]="'q' + question.id"
                    [required]="isMandatory(question)"
                    (change)="updateSurveyDetail(question, $event,i,activeSection, 'dropdown'); clearError(question.id)">
              <option [ngValue]="null">Select</option>
              <option *ngFor="let ans of question.answers" [value]="ans.id">{{ getAnswerLabel(ans) }}</option>
            </select>
            <div class="text-danger mt-1" *ngIf="errors[question.id]">This field is required</div>
          </div>

          <!-- Radio Button -->
          <div *ngIf="question.answerType.name === 'Radio Button'" class="col-xl-6 col-lg-6 col-md-12 mb-4">
            <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
                {{ getQuestionNumber(i,question) }} {{ getQuestionLabel(question) }}
              <span *ngIf="question.mandatory" class="text-danger">*</span>
            </label>
            <div *ngFor="let ans of question.answers">
              <input type="radio"
                     [name]="'q' + question.id"
                     [value]="ans.id"
                     [(ngModel)]="selectedAnswers[question.id]"
                     [required]="isMandatory(question)"
                     (ngModelChange)="updateSurveyDetail(question, $event,i,activeSection, 'radio'); clearError(question.id)">
              {{ getAnswerLabel(ans) }}
            </div>
            <div class="text-danger mt-1" *ngIf="errors[question.id]">This field is required</div>
          </div>

          <!-- Checkbox -->
          <div *ngIf="question.answerType.name === 'Checkbox'" class="col-xl-6 col-lg-6 col-md-12 mb-4">
            <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
               {{ getQuestionNumber(i,question) }} {{ getQuestionLabel(question) }}<span *ngIf="question.mandatory" class="text-danger">*</span>
              <span class="ml-3">
                <input type="checkbox"
                       [(ngModel)]="selectedAnswers[question.id]"
                       (ngModelChange)="updateSurveyDetail(question, $event,i,activeSection, 'checkbox'); clearError(question.id)">
              </span>
            </label>
            <div class="text-danger mt-1" *ngIf="errors[question.id]">This field is required</div>
          </div>

          <!-- Current Date -->
          <div *ngIf="question.answerType.name === 'Current Date'" class="col-xl-6 col-lg-6 col-md-12 mb-4">
            <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
               {{ getQuestionNumber(i,question) }} {{ getQuestionLabel(question) }}<span *ngIf="question.mandatory" class="text-danger">*</span>
            </label>
            <input bsDatepicker
                   [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false, adaptivePosition: true }"
                   class="form-control form-control-sm"
                   placeholder="DD-MM-YYYY"
                   [(ngModel)]="selectedAnswers[question.id]"
                   (ngModelChange)="updateSurveyDetail(question, $event,i,activeSection, 'date'); clearError(question.id)"
                   [required]="isMandatory(question)" />
            <div class="text-danger mt-1" *ngIf="errors[question.id]">This field is required</div>
          </div>

          <!-- Calendar Date -->
          <div *ngIf="question.answerType.name === 'Calendar Date'" class="col-xl-6 col-lg-6 col-md-12 mb-4">
            <label class="font-weight-bold d-block mb-2" style="font-size: 15px;">
                {{ getQuestionNumber(i,question) }} {{ getQuestionLabel(question) }}<span *ngIf="question.mandatory" class="text-danger">*</span>
            </label>
            <input bsDatepicker
                   [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false, adaptivePosition: true }"
                   class="form-control form-control-sm"
                   placeholder="DD-MM-YYYY"
                   [(ngModel)]="selectedAnswers[question.id]"
                   (ngModelChange)="updateSurveyDetail(question, $event,i,activeSection, 'date'); clearError(question.id)"
                   [required]="isMandatory(question)" />
            <div class="text-danger mt-1" *ngIf="errors[question.id]">This field is required</div>
          </div>

     
      </ng-container>
    </ng-container>
    </ng-container>
  </div>
  <div class="d-flex justify-content-between mt-4">
    <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="activeTabIndex === 0">Back</button>
    <button class="btn btn-primary" (click)="submitSurvey()">Next</button>
  </div>
</div>

  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-primary btn-sm" *ngIf="cardClick && ncdSaveEnable"  [disabled]="!isSurveyValid()" (click)="onSubmit()">Save</button>
  <button type="button" class="btn btn-primary btn-sm" *ngIf="cardClick && !ncdSaveEnable"  [disabled]="!isSurveyValid()" (click)="onSubmit2()">Save</button>
  <button type="button" class="btn btn-outline-dark btn-sm" (click)="close()" *ngIf="!beforeCardclick">Back</button>
  <button type="button" class="btn btn-outline-dark btn-sm" (click)="activeModal.close('Close click')">Close</button>
</div>